import { useEffect, useRef } from 'react';
import { useAuthActions } from '@frontegg/react';

export default function Logout() {
  const { logout } = useAuthActions();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    sessionStorage.removeItem('plb_auth_state');
    sessionStorage.removeItem('plb_sso_attempted');
    sessionStorage.removeItem('plb_handoff_token');
    document.cookie = 'plb_custom_origin=; Max-Age=0; path=/';
    document.cookie = 'plb_custom_origin_token=; Max-Age=0; path=/';
    document.cookie = 'plb_custom_origin_tenant=; Max-Age=0; path=/';

    try {
      logout();
    } catch (e) {
      // Ignore — session may already be invalid
    }

    // Redirect to login regardless of logout success
    setTimeout(() => {
      window.location.replace('/login');
    }, 500);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Logging out...</div>
    </div>
  );
}
